import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    targetId: String
  }
  static classes = ["show"]

  connect() {
    this.body = document.querySelector("body")
    const target = document.querySelector(this.targetIdValue)
    
    // Set initial aria-expanded state on the controller element
    if (this.element instanceof HTMLElement) {
      this.element.setAttribute("aria-expanded", "false")
    }
    
    // Set aria-hidden on the target dialog
    if (target) {
      target.setAttribute("aria-hidden", "true")
    }
    
    // If this is a wrapper element (target is a child), listen for target's state changes
    if (target && this.element.contains(target) && this.element !== target) {
      this.targetElement = target
      this.observeTargetChanges()
    }
  }

  observeTargetChanges() {
    // Watch for class changes on the target to sync aria-expanded on wrapper
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          const isOpen = this.targetElement.classList.contains(this.showClass)
          this.element.setAttribute("aria-expanded", isOpen ? "true" : "false")
        }
      })
    })
    
    observer.observe(this.targetElement, { attributes: true })
    this.observer = observer
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  open(event) {
    const target = document.querySelector(this.targetIdValue)
    target.classList.add(this.showClass)
    this.body.style.overflow = "hidden"

    // Set aria-expanded on the element with the controller
    if (this.element instanceof HTMLElement) {
      this.element.setAttribute("aria-expanded", "true")
    }
    
    // Set aria-hidden on the dialog (if different from controller element)
    if (target && target !== this.element) {
      target.setAttribute("aria-hidden", "false")
    }

    const data = event?.currentTarget?.dataset || {}
    this.dispatch("open", { detail: { ...data, target } })
  }

  close() {
    const target = document.querySelector(this.targetIdValue)
    target.classList.remove(this.showClass)
    this.body.style.overflow = "auto"

    // Set aria-expanded on the element with the controller
    if (this.element instanceof HTMLElement) {
      this.element.setAttribute("aria-expanded", "false")
    }
    
    // Set aria-hidden on the dialog (if different from controller element)
    if (target && target !== this.element) {
      target.setAttribute("aria-hidden", "true")
    }

    this.dispatch("close", { detail: { target } })
  }

  toggle(event) {
    const target = document.querySelector(this.targetIdValue)
    if (target.classList.contains(this.showClass)) {
      this.close()
    } else {
      this.open(event)
    }
  }
}
